import { Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMesesFechaRegulacion, getPreguntasDecreto, postGrupoPreguntas, } from "../../../../redux/actions/rgrl";
import { convertDateTimeToNet } from "../../../../util/datetime";
import { decretoToEnum, preguntasDeshabilitadasPorDecreto } from "../../../commons/enums/RgrlEnums";
import CircularLoading from "../../../commons/loading/CircularLoading";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import { StyledRgrl } from "../../../styled/Prevencion";
import PreguntaTable from "./PreguntaTable";

const PreguntaContainer = ({ nextForm }) => {
  const dispatch = useDispatch();
  const [contador, setContador] = useState(0);
  const [grupoActual, setGrupoActual] = useState(null);
  const [totalGrupos, setTotalGrupos] = useState(0);

  const rgrl = useSelector((state) => state.rgrl.preguntas);
  const postRgrl = useSelector((state) => state.rgrl.postRgrl);
  const decretoForm = useSelector((state) => state.rgrl.postRgrl.decretoForm);

  const isLoading = !grupoActual || rgrl.loading;

  useEffect(() => {
    dispatch(getPreguntasDecreto(decretoForm.id));
    dispatch(getMesesFechaRegulacion());
  }, [decretoForm.id]);

  useEffect(() => {
    if (rgrl.data && !postRgrl.preguntasDecreto.preguntas.length) {
      setTotalGrupos(rgrl.data.length);
      setGrupoActual(rgrl.data[contador]);
    }
  }, [rgrl.data]);

  useEffect(() => {
    if (postRgrl.preguntasDecreto.preguntas.length) {

      setTotalGrupos(rgrl.data.length);

      const indiceUltimoGrupo = Math.min(
        postRgrl.preguntasDecreto.preguntas.length,
        rgrl.data.length - 1
      );
      setContador(indiceUltimoGrupo);

      setGrupoActual(() => {
        if (postRgrl?.preguntasDecreto.preguntas?.[indiceUltimoGrupo]) {
          return {
            ...postRgrl.preguntasDecreto.preguntas[indiceUltimoGrupo],
            itemsFormularioArt: postRgrl.preguntasDecreto.preguntas[indiceUltimoGrupo].itemsFormularioArt.map((pregunta) => (
              {
                ...pregunta,
                resultado: pregunta.resultado.toString(),
              }
            ))
          }
        } else {
          return rgrl.data[indiceUltimoGrupo];
        }
      });

    }
  }, []);

  const handleGoBack = (values) => {
    setContador(contador - 1);
    setGrupoActual({
      ...postRgrl.preguntasDecreto.preguntas[contador - 1],
      itemsFormularioArt: postRgrl.preguntasDecreto.preguntas[contador - 1].itemsFormularioArt.map((pregunta) => (
        {
          ...pregunta,
          resultado: pregunta.resultado.toString(),
        }
      ))
    });
    dispatch(
      postGrupoPreguntas({
        ...grupoActual,
        itemsFormularioArt: values.itemsFormularioArt,
      })
    );
  };

  const handleSubmit = (datos) => {
    setContador(contador + 1);
    datos.itemsFormularioArt.forEach((p) => {
      p.fechaLimiteVerificacion = convertDateTimeToNet(
        p.fechaLimiteVerificacion
      );
      p.fechaRegulacion = convertDateTimeToNet(p.fechaRegulacion);
      p.resultado = parseInt(p.resultado);
    });
    const indexToUpdate = postRgrl.preguntasDecreto.preguntas.findIndex(
      (element) =>
        element.idGrupoItemFormularioArt === datos.idGrupoItemFormularioArt
    );
    if (indexToUpdate !== -1 && indexToUpdate === contador) {
      setGrupoActual(
        postRgrl.preguntasDecreto.preguntas[indexToUpdate + 1]
          ? postRgrl.preguntasDecreto.preguntas[indexToUpdate + 1]
          : rgrl.data[indexToUpdate + 1]
      );
    } else {
      setGrupoActual(rgrl.data[contador + 1]);
    }
    dispatch(
      postGrupoPreguntas({
        ...grupoActual,
        itemsFormularioArt: datos.itemsFormularioArt,
      })
    );
    if (contador >= rgrl.data.length - 1) {
      nextForm("PlanillaA");
    }
  };

  const preguntasDeshabilitadas = useMemo(() => {
    return preguntasDeshabilitadasPorDecreto[decretoToEnum(postRgrl.decretoForm.nombre)];
  }, [postRgrl.decretoForm.nombre]);

  const nombreDecreto = decretoToEnum(postRgrl.decretoForm.nombre);
  return (
    <>
      <FechaPresentacionLabel />
      <Paper>
        {isLoading ? (
          <StyledRgrl.LoadingContainer >
            <CircularLoading />
          </StyledRgrl.LoadingContainer>
        ) : (
          <PreguntaTable
            handleSubmit={handleSubmit}
            data={grupoActual}
            contador={contador}
            totalGrupos={totalGrupos}
            handleGoBack={handleGoBack}
            nombreDecreto={nombreDecreto}
            preguntasDecreto={postRgrl.preguntasDecreto.preguntas}
            preguntasDeshabilitadas={preguntasDeshabilitadas}
          />
        )}
      </Paper>

    </>
  );
};

export default PreguntaContainer;
